import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { withApollo } from 'react-apollo';
import Table from '../../components/Global/Table/Table';
import CheckboxInput from '../../components/Global/Inputs/Checkbox';
import Button from '@material-ui/core/Button';
import SelectInput from '../../components/Global/Inputs/Select';
import ErrorNotification from '../../components/common/ErrorNotification';
import {
  columns,
  formatInvoices,
  tableColumnExtensions
} from './InvoiceHelpers';
import { mockInvoiceData } from '../../utils/testHelpers';
import InvoiceIndexStyles from './__styles__/InvoiceIndex.styles';
import _isNumber from 'lodash/isNumber';
import TableRow from './TableRow';
import TableCell from './TableCell';
import { DEFAULT_ROWS_PER_PAGE } from '../../constants/constants';
import { AppContext } from '../../AppProvider';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import combineStyles from './../../utils/combineStyles';
import ButtonStyles from '../../styles/button';
import InvoiceGeneralFilter from '../../components/invoice/GeneralFilter';

export class InvoiceIndex extends Component {
  state = {
    page: 0,
    rowsPerPage: localStorage.getItem('PropelRowsPerPage')
      ? parseInt(localStorage.getItem('PropelRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    invoices: [],
    totalCount: 0,
    rowsSelected: [],
    loading: true,
    error: null
  };

  _handleSelectRow = rowsSelected => this.setState({ rowsSelected });

  _handleDelete = rowsSelected => {
    let {invoices} = this.state;
    rowsSelected.forEach(i => invoices.splice(i,1));
    this.setState({ rowsSelected: [], invoices })
  }

  _changePage = page => {
    this.setState({ page, loading: true }, this.getShipmentList);
  };
  _changeRowsPerPage = rowsPerPage => {
    localStorage.setItem('PropelRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 0 });
    const rows = rowsPerPage === 0 ? DEFAULT_ROWS_PER_PAGE : rowsPerPage;
    this.setState(
      { rowsPerPage: rows, page: 0, loading: true },
      this.getInvoiceList
    );
  };

  async componentDidMount() {
    const { defaultCurrency } = this.context.globalProps.orgInfo.config;
    this.getInvoiceList(defaultCurrency);
  }

  async getInvoiceList(defaultCurrency) {
    const totalCount = mockInvoiceData.length;
    this.setState({
      invoices: formatInvoices(mockInvoiceData, defaultCurrency),
      totalCount: _isNumber(totalCount) ? totalCount : this.state.totalCount,
      loading: false
    });
  }

  _handleDisplayProcessed = () => {
    this.setState({ displayProcessed: !this.state.displayProcessed, page: 0 });
  };

  render() {
    const { classes, t } = this.props;
    const {
      page,
      rowsPerPage,
      loading: dataLoading,
      invoices,
      totalCount,
      error,
      rowsSelected
    } = this.state;
    if (error) {
      return <ErrorNotification message="Error loading page" />;
    }
    return (
      <Fragment>
        <div className={classes.toolBarRootPage}>
          <div className={classes.titleWrapper}>
            <h1 className={classes.headline4}>{t('Invoices')}</h1>
            <InvoiceGeneralFilter />
          </div>
          <div className={classes.actionWrapper}>
            <div className={classes.actions}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                classes={{ label: classes.buttonLabel }}
                component={Link}
                disabled
                to="/invoices/new"
              >
                {t('Create Invoice')}
              </Button>
            </div>
          </div>
        </div>
        <div className={classes.filterOptionsWrapper}>
          <SelectInput
            name={'status'}
            options={[
              {
                title: 'All Statuses',
                value: 'all-statuses'
              }
            ]}
            defaultValue={'all-statuses'}
            classes={{
              root: classes.selectRoot,
              filterColor: classes.filterColor
            }}
            inputLabel={'Status'}
          />
          <SelectInput
            name={'carrier'}
            options={[
              {
                title: 'Carrier: HC-XYZ Shipping Company',
                value: 'xyz-shipping'
              }
            ]}
            defaultValue={'xyz-shipping'}
            inputLabel={'Carrier'}
          />
          <SelectInput
            name={'due'}
            options={[
              {
                title: 'Due HC-JAN 1, 2019 - JAN 2, 2019',
                value: 'jan-1-jan-2'
              }
            ]}
            defaultValue={'jan-1-jan-2'}
            inputLabel={'Due'}
          />
        </div>
        <div>
          <Table
            columnExtensions={tableColumnExtensions}
            name={t('Invoices')}
            columns={columns(t)}
            data={!this.state.displayProcessed ? invoices.filter(x => x.status !== 'PROCESSED'): invoices}
            orderBy="id"
            order={'desc'}
            onChangePage={this._changePage}
            onChangePageRowsPerPage={this._changeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowComponent={TableRow}
            cellComponent={TableCell}
            totalCount={totalCount}
            loading={dataLoading}
            withSelection={true}
            rowsSelected={rowsSelected}
            onDelete={(rowsSelected) => this._handleDelete(rowsSelected)}
            withDownload={false}
            withColumnChooser={false}
            onSelectRow={this._handleSelectRow}
            filterToolbar={
              <CheckboxInput
                label={t('Show Processed')}
                name="activeToggle"
                onChange={this._handleDisplayProcessed}
                value={this.state.displayProcessed}
                classes={{
                  root: classes.noMargin,
                  label: classes.activateToggleLabel
                }}
                dataTest={'active-toggle'}
              />
            }
          />
        </div>
      </Fragment>
    );
  }
}

InvoiceIndex.contextType = AppContext;
export const translatedInvoiceIndex = withNamespaces()(InvoiceIndex);
export default withStyles(
  combineStyles(
    TypographyStyles,
    ButtonStyles,
    InvoiceIndexStyles,
    SpacingStyles
  )
)(withApollo(translatedInvoiceIndex));
